import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const useCategorieLavoro = () => useQuery({ queryKey: ["categorie-lavoro"], queryFn: async () => (await api.get("/preventivi/categorie-lavoro")).data });

export function SelectCategoriaLavoro({ value, onChange, testid, placeholder = "Seleziona", className = "", tutte = false }) {
  const { data: categorie = [] } = useCategorieLavoro();
  const NONE = tutte ? "tutti" : "__none";
  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? (tutte ? "tutti" : "") : v)}>
      <SelectTrigger className={className} data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent><SelectItem value={NONE}>{tutte ? "Tutte le categorie" : "— Nessuna —"}</SelectItem>{categorie.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
    </Select>
  );
}
